import { render, staticRenderFns } from "./CardChatSupport.vue?vue&type=template&id=7f371de4&scoped=true&"
import script from "./CardChatSupport.vue?vue&type=script&lang=js&"
export * from "./CardChatSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f371de4",
  null
  
)

export default component.exports